export default "__VITE_PUBLIC_ASSET__78969ed8__"